import { AppNavItem } from '../../shared/models/app-nav-item.model';
import { RouteAuthPolicy } from '../auth/models';
import { environment } from '../../../environments/environment';

type NavItemWithAuth = AppNavItem & {
  auth?: RouteAuthPolicy;
};

export const PRIMARY_NAV_ITEMS: NavItemWithAuth[] = [
  {
    label: $localize`:@@navigationHomeLabel:Home`,
    href: '/shipments',
    kind: 'internal',
    auth: {
      anyPermissions: ['landing_page']
    }
  },
  {
    label: $localize`:@@navigationTrackShipmentLabel:Track Shipment`,
    href: '/track-shipment',
    kind: 'internal',
    auth: {
      anyPermissions: ['landing_page']
    }
  },
  {
    label: $localize`:@@navigationInvoicingLabel:Invoicing`,
    href: '/statement-billing',
    kind: 'internal',
    auth: {
      anyPermissions: ['statement_billing']
    }
  },
  {
    label: $localize`:@@navigationShipLabel:Ship`,
    href: environment.externalLinks.shipSso,
    kind: 'external', 
    target: '_blank', 
    rel: 'noopener noreferrer'
  },
  { label: $localize`:@@navigationReportsLabel:Reports`,
    href: '/reports',
    kind: 'internal',
    auth: { 
      anyPermissions: ['reporting']
    }
  },
];

export type { NavItemWithAuth };
